module.exports = __webpack_public_path__ + "img/5.e2d4e30e.jpg";